<template>
    <div>
        <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre del Usuario</th>
                <th :class="StyleTh">Email</th>
                <th :class="StyleTh">Perfil</th>
			</template>
            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><h6 :class="StylePr">{{lista.NombreCompleto}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Correo}}</p></td>
                    <td><p :class="StyleTd">{{lista.Nombre}}</p></td>
                </tr>
            </template>
        </CList>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<!-- <Form :usuarios="Usuarios" :poBtnSave="oBtnSave"></Form> -->
                <Form :poBtnSave="oBtnSave" :Asignados="ListaArrayRows" :IdAgente="ObjAgente.IdAgente"></Form>
			</template>
		</CModal>
    </div>
</template>

<script>
import Form from '@/views/catalogos/usuarioxagente/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionUsuariosAgente';
export default {
    name:'ListaUsuariosxAgente',
    props:['pObjEnviado'],
    components:{
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Gerentes de boda y Coordinadores de',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: 'Hoteles & Empresas',
                ShowFiltros:    false,
                ShowSearch:     false,
                ShowEntradas:   false,
                ShowPaginador:  false,
                BtnNewName: 'Agregar/Quitar'
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Asignar Gerente y Coordinador",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'xl'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjAgente: {},
            // Usuarios:[]
        }
    },
    methods: {
        async Lista(){
            this.ConfigList.ShowLoader = true;
            await this.$http.get('usuariosxagente',{
                params:{
                    IdAgente:this.ObjAgente.IdAgente
                }
            }).then((res) => {
                this.ListaArrayRows     = res.data.data;
                this.segurity           = res.data.segurity;
            }).finally(() => {
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar(){
            this.$router.push({name:'hotelEmpresa',params:{}});
        },
        ListarUsuarios(){
            this.$http.get('users',{
                params:{
                    Entrada:10000,
                    IdSucursal:JSON.parse(sessionStorage.getItem('user')).IdSucursal
                }
            }).then((res) => {
                this.Usuarios=res.data.data.usuarios.data;
            });
        }
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objAgente',JSON.stringify(this.pObjEnviado));
        }

        this.ObjAgente = JSON.parse(sessionStorage.getItem('objAgente'));
        this.ConfigList.Title=this.ConfigList.Title+' '+this.ObjAgente.NombreComercial;

        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
        // this.ListarUsuarios();
    },
    mounted()
    {
        this.Lista();

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>